// Shared helpers for the Commodities (MCX) screens — dedicated to this
// section only (not imported by, or importing from, any Stocks page), per
// the explicit "don't re-use Stocks related screens" instruction.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fmt = (v, d = 2) =>
  v == null ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: d });

export const fmtPct = (v, d = 2) => {
  if (v == null) return "—";
  const n = Number(v);
  return `${n >= 0 ? "+" : ""}${fmt(n, d)}%`;
};

export const pctColor = (v) => (v == null ? "var(--text-muted-2)" : v >= 0 ? "var(--bull)" : "var(--bear)");

export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) : "—";

export const STRATEGY_LABELS = {
  reversal: "Reversal Entry Zones",
  vwap_momentum: "MCX VWAP Momentum",
};

export default axios;
